import {
  FETCHSTATE_SUCCESS_ACTION,
  FETCHDISTRICT_SUCCESS_ACTION,
  FETCHDISTRICT_FAIL_ACTION,
  FETCHBANKS_SUCCESS_ACTION,
  FETCHBANKS_FAIL_ACTION
} from "./action";

const initialState = {
  processing: false,
  error: false
};

export default function(state: any = initialState, action: Function) {
  switch (action.type) {
    case FETCHSTATE_SUCCESS_ACTION:
      return {
        ...state,
        states: action.payload
      };

    case FETCHDISTRICT_SUCCESS_ACTION:
      // console.log(action.payload);
      return {
        ...state,
        districts: action.payload.rows
      };
    case FETCHDISTRICT_FAIL_ACTION:
      // console.log(action.payload);
      return {
        ...state,
        districts: ""
      };
    case FETCHBANKS_SUCCESS_ACTION:
      return {
        ...state,
        banks: action.payload
      };

    default:
      return {
        ...state
      };
  }
}
